import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axiosInstance from "../../../../axiosInstance";
import { API_URL } from "../../../../config";

function EmpPostAJobPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const template = location.state?.template || {};

    const [formData, setFormData] = useState({
        title: "",
        subject: "",
        body: "",
        status: ""
    });

    useEffect(() => {
        if (template) {
            setFormData({
                title: template.title || "",
                subject: template.subject || "",
                body: template.body || "",
                status: template.status || ""
            });
        }
    }, [template]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axiosInstance.put(`${API_URL}/admin/edit-emailTemplate/${template.id}`, {
                title: formData.title,
                subject: formData.subject,
                body: formData.body,
                status: formData.status
            });
            if (response.data.status === 200) {
                alert("Email template updated successfully.");
                navigate("/employer/emails"); // change route if needed
            } else {
                alert(response.data.message || "Update failed.");
            }
        } catch (error) {
            console.error("Update error:", error);
            alert("Something went wrong.");
        }
    };

    return (
        <>
            <div className="wt-admin-right-page-header clearfix">
                <h2>Email Template Edit</h2>
                <div className="breadcrumbs">
                    <a href="#">Home</a><a href="#">Dashboard</a><span>Edit Template</span>
                </div>
            </div>

            <div className="panel panel-default">
                <div className="panel-heading wt-panel-heading p-a20">
                    <h4 className="panel-tittle m-a0"><i className="fa fa-suitcase" /> Edit Email Template</h4>
                </div>

                <div className="panel-body wt-panel-body p-a20 m-b30">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            {/* Title */}
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Title</label>
                                    <textarea
                                        className="form-control"
                                        rows={4}
                                        name="title"
                                        value={formData.title}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            {/* Subject */}
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Subject</label>
                                    <textarea
                                        className="form-control"
                                        rows={4}
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Status</label>
                                    <div className="ls-inputicon-box">
                                        <select
                                            className="wt-select-box selectpicker"
                                            data-live-search="true"
                                            title=""
                                            rows={4}
                                            id="status"
                                            data-bv-field="size"
                                            name="status"
                                            value={formData.status}
                                            onChange={handleChange}
                                        >
                                            <option className="bs-title-option" value="">Select Status</option>
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                        <i className="fs-input-icon fa fa-info-circle" />
                                    </div>
                                </div>
                            </div>

                            {/* Body */}
                            <div className="col-xl-12 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Body</label>
                                    <textarea
                                        className="form-control"
                                        rows={10}
                                        name="body"
                                        value={formData.body}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            {/* Status */}

                            {/* Submit */}
                            <div className="col-lg-12">
                                <button type="submit" className="site-button m-r5">Update Template</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default EmpPostAJobPage;
